export const anchorWidgetHandler = (widget, nextElement, cb = null) => {

  if (!widget) return;

  widget.addEventListener('keydown', (e) => {
    const targetElement = e.target.closest('li');
    const anchor = targetElement?.firstElementChild;

    if (!targetElement || !anchor) return;

    if (e.key === 'Tab' && document.activeElement === widget?.children?.[widget?.children?.length - 1]) {
      e?.preventDefault();
      widget?.children?.[0].focus();
    }

    if (e?.key === 'Enter' || e?.key === ' ') {
      e?.preventDefault();
      cb?.(anchor.getAttribute('href'));
      if (nextElement) {
        nextElement?.focus();
      }
    }

  });
};
